import React, { useEffect, useState } from 'react';
import BASE_URL from '../config'; // Import BASE_URL

const ShowRefinance = () => {
  const [records, setRecords] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${BASE_URL}api/proxy?action=latest_febdata`) // Use BASE_URL
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          setRecords(data.data);
        } else {
          setError('No data found.');
        }
      })
      .catch(() => {
        setError('Failed to fetch data.');
      });
  }, []);

  const formatDate = (dateObj) => {
    if (!dateObj || !dateObj.date) return '';
    const date = new Date(dateObj.date);
  
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
  
    const time = date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    });
  
    return `${day}-${month}-${year} ${time}`;
  };
  
  

  return (
    <div className="container mt-4">
      <h5>Latest Refinance Records</h5>
      {error && <div className="alert alert-danger">{error}</div>}
      <div
  className="table-responsive"
  style={{ maxHeight: '400px', overflowY: 'auto' }}
>
        <table className="table table-striped table-bordered table-sm" style={{ fontFamily: 'Arial' , whiteSpace: 'nowrap' }}>
          <thead className="thead-dark">
            <tr>
              <th>ID</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>ZIP</th>
              <th>Home Phone</th>
              <th>Email</th>
              <th>House Type</th>
              <th>House Value</th>
              <th>Loan Amount</th>
              <th>Cash Out</th>
              <th>FHA Loan</th>
              <th>Credit Status</th>
              <th>Military</th>
              <th>Upload Type</th>
              <th>Lead Date</th>
              <th>Created At</th>
              <th>Journaya ID</th>
              <th>IP Address</th>
              <th>Time Saved</th>
              <th>TrustedForm URL</th>
            </tr>
          </thead>
          <tbody>
            {records.map((row, idx) => (
              <tr key={idx}>
                <td>{row.nid}</td>
                <td>{row.firstname}</td>
                <td>{row.lastname}</td>
                <td>{row.streetaddress}</td>
                <td>{row.city}</td>
                <td>{row.state}</td>
                <td>{row.zip}</td>
                <td>{row.homephone}</td>
                <td>{row.email}</td>
                <td>{row.housetype}</td>
                <td>{row.housevalue}</td>
                <td>{row.loanamount}</td>
                <td>{row.cashout}</td>
                <td>{row.fhaloan}</td>
                <td>{row.creditstatus}</td>
                <td>{row.military}</td>
                <td>{row.uploadtype}</td>
                <td>{formatDate(row.leaddate)}</td>
                <td>{formatDate(row.createdat)}</td>
                <td>{row.jornayaleadidtoken}</td>
                <td>{row.ipaddress}</td>
                <td>{row.timesaved}</td>
                <td>
                  {row.trustedformurl ? (
                    <a href={row.trustedformurl} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  ) : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShowRefinance;